module.exports = __webpack_public_path__ + "static/calabriologo-e81ff877d38b220f08f4b8d86f7b727e.svg";